export const Assets = {
  jumbotron_background: require('./jumbotron_background.png'),
  logo_large: require('./logo_large.png'),
  mobile_body: require('./mobile_body.png'),
  mobile_introduce: require('./mobile_introduce.png'),
  mobile_progress: require('./mobile_progress.png'),
  mobile_reward: require('./mobile_reward.png'),
  mobile_title: require('./mobile_title.png'),
  pc_body: require('./pc_body.png'),
  pc_introduce: require('./pc_introduce.png'),
  pc_progress: require('./pc_progress.png'),
  pc_reward: require('./pc_reward.png'),
  pc_title: require('./pc_title.png'),
  reward_background: require('./reward_background.png'),
  snuh_logo: require('./snuh_logo.png'),
}
